<template>
<div>
    <job-status-relation-list></job-status-relation-list>
</div>
</template>
<script>
export default {}
</script>
